<template>
  <div
    class="menus"
    ref="menus"
  >
    <a-row
      justify="end"
      align="middle"
    >
      <a-col
        :span="2"
        class="welcome"
      >
        欢迎登陆系统 !
      </a-col>
      <a-col :span="2">
        <Headimg />
      </a-col>
    </a-row>

    <a-row class="">
      <a-col :offset="4">
        <div class="top">
          <img
            class="logo"
            src="@/assets/images/index/logo.jpg"
          >
          <div class="title">
            <h6>{{pageOption.corporateNameChinese}}</h6>
            <p>{{pageOption.corporateNameEnglish}}</p>
          </div>
        </div>
        <h3 class="name">{{pageOption.systemName}}</h3>
      </a-col>
    </a-row>
    <a-row>
      <a-col
        :offset="4"
        class="col"
      >
        <div
          v-for="(item, i) in userRouters"
          :key="i"
          class="hexagon"
          @mouseenter="enter(i)"
          @mouseleave="leave(i)"
          @click="!item.alwaysShow && goto(item.path, item.name)"
        >
          <img :src="'http://sc2.jiulangkeji.cn/images/'+item.meta.icon">
          <p>{{item.name}}</p>
          <div
            v-if="item.childShow"
            v-for="(child, j) in item.children"
            class="sexangle"
            @click="!child.alwaysShow && goto(child.path, item.name+' / '+child.name)"
          >
            <img :src="'http://sc2.jiulangkeji.cn/images/'+child.meta.icon">
            <p>{{child.name}}</p>
            <div
              v-if="item.childShow"
              v-for="(grandson, j) in child.children"
              class="sexangle sex"
              @click="goto(grandson.path, item.name+' / '+grandson.name)"
            >
              <img :src="'http://sc2.jiulangkeji.cn/images/'+grandson.meta.icon">
              <p>{{grandson.name}}</p>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
  <Copyright />
</template>

<script>
// @ is an alias to /src
import Headimg from "@/components/header/headimg.vue";
import Copyright from "@/components/Copyright.vue";

export default {
  name: "Menus",
  components: {
    Headimg,
    Copyright,
  },
  data() {
    return {
      menuList: [],
      hover0: false,
      hover1: false,
      hover2: false,
      hover3: false,
      hover4: false,
      hover5: false,
      hover6: false,
      hover7: false,
      hover8: false,
      fileList: '',
      pageOption: {},
      userRouters: []
    }
  },
  beforeCreate() {
    if (localStorage.getItem('refresh') == 'true') {
      localStorage.setItem('refresh', false)
      this.$router.go(0);
    }
  },
  mounted() {
    this.pageOption = JSON.parse(localStorage.getItem('pageOption'))
    this.userRouters = JSON.parse(localStorage.getItem('userRouters'))
    for (let i = 0; i < this.userRouters.length; i++) {
      let el = this.userRouters[i]
      if (el.alwaysShow) {
        el.childShow = false
      }
    }
    console.log(this.userRouters)
  },
  methods: {
    goto(path, name, develop) {
      console.log(path, name)
      if (name == '大屏显示') {
        // this.$message.info('正在开发');
        this.goto2(path)
      } else {
        this.$router.push({ path: path, query: { name: name } }, () => { }).catch(res => {
          console.log(res)
        });
      }
    },
    goto2(path) {
      const newPage = this.$router.resolve({ name: 'LargeScreen' }, () => { })
      console.log(newPage)
      window.open(newPage.href, '_blank');
    },
    enter(i) {
      this.userRouters[i].childShow = true
    },
    leave(i) {
      this.userRouters[i].childShow = false
    }
  }
};
</script>
<style scoped>
.menus {
  height: 100vh;
  padding-top: 20px;
  background: url("~@/assets/images/menus-bg.png") no-repeat center;
  background-size: cover;
}
.welcome {
  font-size: 16px;
  font-family: Alibaba;
  font-weight: normal;
  color: #fff;
}
.top {
  margin: 100px 0 50px;
  display: flex;
  align-items: center;
}
.logo {
  width: 64px;
  height: 56px;
  margin-right: 12px;
}
.title h6 {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #6c35ce;
}
.title p {
  font-size: 12px;
  font-weight: bold;
  color: #fff;
}
.name {
  margin: 50px 0 100px;
  font-size: 38px;
  color: #fff;
}
.col {
  display: flex;
  flex-wrap: wrap;
  width: 750px;
}
.hexagon {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 112px;
  margin: 0 80px 46px 0;
  background: url("~@/assets/images/hexagon.png") no-repeat center;
  background-size: 100% 100%;
}
.hexagon:hover {
  cursor: pointer;
}
.hexagon img {
  width: 43px;
}
.hexagon p {
  font-size: 16px;
  color: #fff;
}
.sexangle {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 78px;
  height: 86px;
  background: url("~@/assets/images/hexagon.png") no-repeat center;
  background-size: 100% 100%;
  z-index: 2;
  display: none;
}
.hexagon > .sexangle:nth-of-type(1) {
  display: flex;
  position: absolute;
  left: -36px;
  top: -66px;
}
.hexagon > .sexangle:nth-of-type(2) {
  display: flex;
  position: absolute;
  right: -36px;
  top: -66px;
}
.hexagon > .sexangle:nth-of-type(3) {
  display: flex;
  position: absolute;
  right: -78px;
}
.hexagon > .sexangle:nth-of-type(4) {
  display: flex;
  position: absolute;
  right: -36px;
  bottom: -66px;
}
.hexagon > .sexangle:nth-of-type(5) {
  display: flex;
  position: absolute;
  left: -36px;
  bottom: -66px;
}
.hexagon > .sexangle:nth-of-type(6) {
  display: flex;
  position: absolute;
  left: -78px;
}
.sex {
  width: 64px;
  height: 70px;
  font-size: 12px;
}
.sex img {
  width: 30px;
}
.sexangle .sex:nth-of-type(1) {
  display: flex;
  position: absolute;
  left: -30px;
  bottom: -55px;
}
.sexangle .sex:nth-of-type(2) {
  display: flex;
  position: absolute;
  left: -66px;
}
.son1 {
  display: flex;
  position: absolute;
  left: -36px;
  top: -66px;
}
.son2 {
  display: flex;
  position: absolute;
  right: -36px;
  top: -66px;
}
.son3 {
  display: flex;
  position: absolute;
  right: -78px;
}
.son4 {
  display: flex;
  position: absolute;
  right: -36px;
  bottom: -66px;
}
.son5 {
  display: flex;
  position: absolute;
  left: -36px;
  top: 66px;
}
.son6 {
  display: flex;
  position: absolute;
  left: -78px;
}
.sexangle p {
  font-size: 12px;
}
</style>